/**
 * Application-level branded loading state (Stage 19J).
 * Use for auth bootstrap / blank-page fallbacks — not section skeletons.
 */
export function SpoxLoader({
  label = 'Loading Spox',
  testId = 'spox-loader',
}: {
  label?: string
  testId?: string
}) {
  return (
    <div className="spox-loader" role="status" aria-live="polite" aria-label={label} data-testid={testId}>
      <img
        className="spox-loader__mark"
        src="/brand/logo/icon/full-colour/spox-icon-transparent.png"
        alt=""
        width={72}
        height={72}
        decoding="async"
      />
      <span className="spox-loader__dots" aria-hidden="true">
        <span />
        <span />
        <span />
      </span>
    </div>
  )
}
